<template>
  <div>
    <div :style="dateDivStyle">
      {{ value.date | formatTime('MM/DD')}} {{ value.date | readableWeek }}
      <span :style="unitSpanStyle" v-show="isFirst">
        {{ unit }}
      </span>
    </div>
    <div :id="`pumpOneDayGraph_co_${id}`" :style="{ width: w + 'px', height: Math.round(h * ((29) / 182) + 1.05 * lfs) + 'px'}">
    </div>
    <div :id="`pumpOneDayGraph_${id}`" :style="{ width: w + 'px', height: (h - lfs * 4.5) + 'px'}">
    </div>
    <div :id="`pumpOneDayGraph_bar_${id}`" :style="{ width: w + 'px', height: (h - Math.round(h * (29 / 182))) + 'px'}">
    </div>
  </div>
</template>
<script>
import reDrawTrigger from '@mx/reDrawTrigger'
import { qcopy, isHighGlu, isLowGlu, isNormalGlu, findObjIndexInArray, padZero, trimEndZero } from '@u'
import { derrorFactory, errorFactory } from '@u/log'
// import $ from 'jquery'
import dayjs from 'dayjs'
import { pumpGetSymbol } from '../pumpGetSymbol'
import { readableWeek } from '@/filters'
import { _getPumpBasalFromRecords, _appendTwoPointsToBasals, _getPumpBasalShouldShowLabelRecordsFromBasals, _getPumpBigDosageFromRecords, _getMergedPumpBigDosageFromRecords, SVG, _sortCgmRecordListByTimeAsc, getBigDosageData, getBigDosageType } from '@u/reportHelper'
import { _otherDataGetPumpClockFilter, _otherDataGetTempBasalFilter, _otherDataGetTempBasalStopFilter, _isTempBasalVersion2, _getTempBasalDurationVersion2, _isTempBasalVersion2Percent, _getTempBasalVersion2Percent, _otherDataGetModuleChangeFilter, _otherDataGetReservoirChangeFilter, _otherDataGetTimeZoneFilter, _evenEventIcons, _evenVerticalDashLine } from '@u/reportHelperPump'
import { _transferBasalData, _transferBigDosageBarData, _createLineAreaWithDiffentColor, labelSize, _tempBasalDuration } from '@u/reportHelperPump'
import { _transferBGData, _transferYHeightToBGValue } from '@u/reportHelperBG'
import { _getUTCOffset } from '@u/timezoneDict'
import { _axisLabelColor, _axisLineColor } from '@u/reportUiVariables-pump'

const derror = derrorFactory('pumpOneDayGraph', true) // 第二个参数是disabled
const error = errorFactory('pumpOneDayGraph', true)

const _eventIconRatio = 0.8 // 图标大小伸缩比例(同chartDailyPump比较)

function _createVerticalDashLineWithBigDosage(bigDosage = [], extra = {}, withRectLabel = false) {
  return []
}

function _createVerticalDashLineWithSplitedExtendedBigDosageLabelCfg(bigDosages = [], extra = {}) {
  // 获取markline地址
  derror(`_createVerticalDashLineWithSplitedExtendedBigDosageLabelCfg, bigDosages: `, bigDosages)
  const { lfw, lfs, bigDosageTypeColorsLinear } = extra || {}
  const type = '1'
  
  // const gap = 0.8 // 标签文案的位移距离
  
  const _eventDatas = bigDosages.map(r => {
    const { check_time, duration, totalDuration } = r
    const data = getBigDosageData(r, false) // 注意第二个参数，必须传false，才会有时候取totalBolus、有时候totalExtendBolus
    const dataKeys = Object.keys(r).filter(k => /^data[0-9]*/.test(k))
    
    const maxData = dataKeys.reduce((rst, cur) => {
      const k = cur
      const v = +r[k]
      // derror(`k: ${k}, v: ${v}`)
      return Math.max(rst, v)
    }, +r['data'])
    
    const x = +dayjs(check_time).add(Math.floor((totalDuration / 2) / 1000), 'second')
    derror(`x: ${x} ${dayjs(x).format('YYYY-MM-DD HH:mm:ss')}, duration: ${duration / 1000}, totalDuration: ${totalDuration / 1000}, y(maxData): ${maxData}, dataKeys: ${dataKeys} r: `, r)
    return [
      x,
      _transferBigDosageBarData(data),
      data,
      totalDuration
      // `${totalBolus} ${_tempBasalDuration(totalDuration / 1000)}`
    ]
  })
  
  const oneLabelCfgCom = {
    name: '分割的多条记录的延长量',
    type: 'line',
    showBackground: true,
    yAxisIndex: 0,
    lineStyle: {
      width: 0
    },
    // showSymbol: true,
    // symbol: (value, params) => {
    //   return ''
    // },
    symbolSize: 0, // 默认是showSymbol的，通过symbolSize为0将symbo隐去，否则label一直显示不出来
    label: {
      show: true,
      fontSize: labelSize,
      position: 'top',
      align: 'left',
      color: 'black',
      // offset: [0, 0 - 0.1 * lfs],
      offset: [0, 0],
      rich: {
        v: {
          fontSize: labelSize,
          align: 'left',
          backgroundColor: `transparent`
        },
        bg: {
          backgroundColor: `rgba(${bigDosageTypeColorsLinear[type]['r']}, ${bigDosageTypeColorsLinear[type]['g']}, ${bigDosageTypeColorsLinear[type]['b']}, 0.8)`,
          color: 'white',
          fontSize: labelSize * 0.8,
          // padding: [0.1 * lfs, 0.6 * lfs, 0.6 * lfs, 0.1 * lfs],
          padding: [0.1 * lfs, 0.2 * lfs],
          align: 'left',
          borderRadius: 0.1 * lfs
        }
      },
      formatter: (params) => {
        // derror(`label format data: `, data)
        const { data = [] } = params
        const [a, b, trueV, totalDuration] = data
        return `{v|${trueV}}\n{bg|${_tempBasalDuration(totalDuration / 1000)}}`
      }
    },
    smooth: true,
    data: _eventDatas
  }  
  
  const rst = [
    oneLabelCfgCom
  ]
  
  derror(`_createVerticalDashLineWithSplitedExtendedBigDosageLabelCfg, rst: `, rst)
  return rst
}

let _id = 1
const nowT = dayjs()
const fmt = 'YYYY-MM-DD HH:mm:ss'
const _mealLabelColor = 'rgba(243, 178, 69, 1)'
const _mealBg = 'rgba(243, 178, 69, 0.2)'
// const _axisLabelColor = 'rgba(33, 25, 9, 1)'
// const cmaxC = 'rgba(240, 189, 90, 0.43)'
// const cminC = 'rgba(223, 67, 42, 0.43)'
// const normalC = 'rgba(135, 183, 91, 0.43)'
// const cmaxC = 'rgba(240, 189, 90, 1)'
// const cminC = 'rgba(223, 67, 42, 1)'
// const normalC = 'rgba(135, 183, 91, 1)'
// const normalC = '#70B603'
// const cmaxC = '#ffaf00'
// const cminC = '#ff0000'

function _whatBasalsRange(_basals = [], timepoint) {
  const rst = {
    index: -1,
    value: undefined
  }
  
  if (!timepoint) return rst
  let recordTimeDayjs = +dayjs(timepoint)
  if (!_basals || !_basals.length) {    
    return rst
  }
  const last = _basals[_basals.length - 1]
  const lastT = last[0]
  
  // const lastTstr = dayjs(lastT).format('YYYY-MM-DD HH:mm:ss')
  // const ts = dayjs(timepoint).format('YYYY-MM-DD HH:mm:ss')
  // if (dayjs(timepoint).format('YYYY-MM-DD') === '2023-06-02') {
  //   if (lastTstr === ts) {
  //     debugger      
  //   }
  // }
  if (lastT - recordTimeDayjs < 0) {
    // timepoint时间超过_basals最大的那个时间戳
    // 那么将timepoint设成最后一个_basals的时间戳
    recordTimeDayjs = lastT
  }
  let _v = -1
  let _vIndex = -1
  do {
    const l = _basals.length
    for (let i = 0; i < l; i++) {
      const basal = _basals[i]
      const time = dayjs(basal[0])
      const value = basal[1]
      const nextB = _basals[i + 1]
      if (nextB === undefined || i >= (l - 1)) { // 最后一个_basals
        if (time - recordTimeDayjs <= 0) {
          // 找到
          _v = value
          _vIndex = i
          break // 已找到，break
        } else {
          break          
        }
      }
      const time2 = dayjs(nextB[0])
      
      if (time - recordTimeDayjs <= 0 && time2 - recordTimeDayjs > 0) {
        _v = value
        _vIndex = i
        break // 已找到，break
      }
    }
    /* eslint-disable-next-line*/
  } while (false)
  if (_vIndex >= 0) {
    rst.index = _vIndex
    rst.value = _v
  }
  
  return rst
}

const _eventDatasHeight = 10.1
export default {
  name: 'CCPumpOneDayGraph',
  mixins: [reDrawTrigger],
  props: {
    quickPumpTagList: { // 立即大剂量(用户通过泵体的快捷键打的大剂量)
      type: [Array],
      default: () => []
    },
    uploadEvents: { // 上传数据事件
      type: [Array],
      default: () => []
    },
    allDeadlineGaps: {
      type: [Array],
      default: () => []
    },
    noMealHighlight: {
      type: [Boolean],
      default: false
    },
    noHorizontalSplitLine: {
      type: [Boolean],
      default: false
    },
    setting: {
      type: [Object],
      default: () => {
        return {}
      }
    },
    isFirst: {
      type: [Boolean],
      default: false
    },
    isLast: {
      type: [Boolean],
      default: false
    },
    basalRateInfoMsg: {
      type: [Array],
      default: () => []
    },
    basalRateBaseSetting: {
      type: [Array],
      default: () => []
    },
    warnings: {
      type: [Array],
      default: () => []
    },
    value: {
      type: [Object],
      default: () => {}
    },
    yesterday: {
      type: [Object],
      default: () => {}
    }
  },
  data() {
    _id++
    const id = `pump1daygraph_${+new Date()}_${_id}`
    return {
      id,
      bigDosageMinWidthMinutes: 30 // 这个值变了，也要修改PumpBolusDetailTable里头写死的值
    }
  },
  computed: {
    dateDivStyle() {
      const { lfs, dateDivH, isFirst } = this
      const rst = { position: 'relative', color: 'black', 'height': dateDivH + 'px', 'lineHeight': dateDivH + 'px', fontSize: (18 / 12) * lfs + 'px', 'fontWeight': 'bold' }
      if (isFirst) {
        rst.textIndent = (28 / 12) * lfs + 'px'
      } else {
        rst.textIndent = (36 / 12) * lfs + 'px'
      }
      return rst
    },
    unitSpanStyle() {
      const { lfs } = this
      const rst = { position: 'absolute', top: (18 / 12) * lfs + 'px', left: (0 - lfs) + 'px' }
      Object.assign(rst, {
        color: _axisLabelColor,
        fontWeight: 800,
        fontSize: (16 / 12) * lfs
      })
      return rst
    },
    dateDivH() {
      const { lfs } = this
      return Math.round((4 - 1.05) * lfs) // 1.05lfs是三餐label高度;4是三餐+日期（dateDivH）之和
    },
    reservoirChanges() { // 换底板事件
      const { value } = this
      const { date, otherData = [] } = value
      const changeRecords = (otherData.filter(_otherDataGetReservoirChangeFilter)).sort((first, second) => dayjs(first.dateTimeStr) - dayjs(second.dateTimeStr)) // 升序, dateTimeStr小的在数组前面
      
      const changes = changeRecords.filter(v => dayjs(`${v.dateTimeStr}`).format('YYYY-MM-DD') === `${date}`)
      
      if (!changes.length) {
        return []
      }
      return changes
    },
    changeModules() {
      const { value } = this
      const { threeChartData = {}, date, otherData = [] } = value
      const changeRecords = (otherData.filter(_otherDataGetModuleChangeFilter)).sort((first, second) => dayjs(first.dateTimeStr) - dayjs(second.dateTimeStr)) // 升序, dateTimeStr小的在数组前面
      
      const changes = changeRecords.filter(v => dayjs(`${v.dateTimeStr}`).format('YYYY-MM-DD') === `${date}`)
      
      if (!changes.length) {
        return []
      }
      return changes
    },
    sortedBasalRateBaseSetting() {
      const { basalRateBaseSetting = [] } = this
      const rst = basalRateBaseSetting.slice()
      rst.sort((first, second) => first.settingIndex - second.settingIndex) // 升序, settingIndex小的在数组前面
      return rst
    },
    lastUploadTime() { // (整个报告期间，而不是今天的最后一次数据上传)最后一次数据上传(绘图截止到这个事件的时间点)
      const { uploadEvents = [] } = this
      if (uploadEvents && uploadEvents.length) {
        const sorted = (uploadEvents.slice().sort((a, b) => dayjs(b.uploadTimeStr) - dayjs(a.uploadTimeStr)))
        const obj = sorted[0]
        derror(`lastUploadTime, obj: `, obj)
        return +dayjs(obj.uploadTimeStr)
      } else {
        return 0
      }
    },
    bigDosageMerged() {
      // const { value, bigDosageMinWidthMinutes } = this
      // const { threeChartData = {}} = value
      // const { insulinChart = {}} = threeChartData
      // const { list: pumpRecord } = insulinChart
      
      const { bigDosage, bigDosageMinWidthMinutes } = this
      
      const rst = _getMergedPumpBigDosageFromRecords(bigDosage, bigDosageMinWidthMinutes) // 注意，这里和ChartDailyPump组件逻辑不一样，ChartDailyPump是从threeChartData.insulinChart.list来作为array处理，而这里直接使用bigDosage
      
      return rst      
    },
    bigDosage() {
      const { value, bigDosageMinWidthMinutes } = this
      const { threeChartData = {}} = value
      const { insulinChart = {}} = threeChartData
      const { list2: pumpRecord } = insulinChart
      
      const rst = _getPumpBigDosageFromRecords(pumpRecord, bigDosageMinWidthMinutes)
      return rst
    },
    trueW() {
      const ds = this.ds      
      const r = 366 / 1754
      // const r = 430 / 1754
      // derror(`[bar]computed w: ${ds}, rst: ${r * ds}`)
      
      return (r * ds)
    },
    w() {
      const trueW = this.trueW
      
      const grid = this.getCommonGridOpt()
      
      const { isFirst, lfs, isLast } = this
      
      let rst = trueW
      
      if (isFirst) {
        rst += grid.left
      }
      if (isLast) {
        rst += grid.right
      }
      return rst
    },
    totalH() {
      const { trueW: w } = this
      
      return (458 / 366) * w
    },
    h() {
      const { totalH } = this
      return totalH / 2
    }
  },
  mounted() {
    this.render(false)
  },
  methods: {
    getEventDatas() { // 返回 换底板、告警(alarm)、上传记录, 因为这些图标可能会挤压在一起
      const { value, lfs, reservoirChanges = [], warnings = [], uploadEvents = [] } = this
      const { threeChartData = {}, date } = value
      
      const rst = []
      
      // 换底板
      rst.push(...reservoirChanges.map(v => {
        return [
          +dayjs(v.dateTimeStr),
          _eventDatasHeight,
          'reservoir'
        ]
      }))
      
      // 告警
      const warns = warnings.filter(v => `${v.date}` === `${date}`)
      if (warns.length) {
        const list = warns[0] ? warns[0].list : []
        rst.push(...list.map(v => {        
          return [
            +dayjs(v.dateTimeStr),
            _eventDatasHeight,
            'alarm'
          ]
        }))
      }
      
      // 上传记录
      const uploads = uploadEvents.filter(obj => { // 过滤出今天的upload事件的series
        const fmt = 'YYYY-MM-DD'
        return dayjs(date).format(fmt) === dayjs(obj.uploadTimeStr).format(fmt)
      })
      rst.push(...uploads.map(v => {
        return [
          +dayjs(v.uploadTimeStr),
          _eventDatasHeight,
          'upload'
        ]
      }))
      
      // 先排序
      rst.sort((first, second) => dayjs(first[0]) - dayjs(second[0]))
      
      _evenEventIcons(rst, +dayjs(date), 60 * 30) // 至少间隔30分钟
      return rst
    },
    getReservoirChangeSeries() {
      const events = this.getEventDatas()
      const _eventDatas = events.filter(arr => arr[2] === 'reservoir')
      
      const rst = {
        name: 'reservoirAlarms',
        type: 'line',
        showBackground: true,
        lineStyle: {
          width: 0
        },
        showSymbol: true,
        symbol: (value, params) => {
          const eventType = value[2]
          const symbol = pumpGetSymbol(eventType)
          return symbol
        },
        symbolSize: 20,
        smooth: true,
        data: _eventDatas
      }
      return [rst]
    },
    getPumpAlarmSeries() {
      const events = this.getEventDatas()
      const _eventDatas = events.filter(arr => arr[2] === 'alarm')
      
      const rst = {
        name: 'pumpAlarms',
        type: 'line',
        showBackground: true,
        lineStyle: {
          width: 0
        },
        showSymbol: true,
        symbol: (value, params) => {
          const eventType = value[2]
          const symbol = pumpGetSymbol(eventType)
          return symbol
        },
        symbolSize: 20,
        smooth: true,
        data: _eventDatas
      }
      return [rst]
    },
    getPumpClockSeries() {
      const { value, lfs } = this
      const { threeChartData = {}, date, otherData = [] } = value
      const changeTimes = otherData.filter(_otherDataGetPumpClockFilter).sort((first, second) => dayjs(first.dateTimeStr) - dayjs(second.dateTimeStr))
      
      const clocks = (changeTimes.filter(v => dayjs(`${v.dateTimeStr}`).format('YYYY-MM-DD') === `${date}`)).map(obj => {
        const isTimeZoneChangeRecord = _otherDataGetTimeZoneFilter(obj)
        const rst = {
          ...qcopy(obj)
        }
        rst['isTimeZoneChangeRecord'] = isTimeZoneChangeRecord
        return rst
      })
      
      if (!clocks.length) {
        return []
      }
      
      const _eventDatas = clocks.map(v => {
        const { eventType, isTimeZoneChangeRecord } = v
        if (isTimeZoneChangeRecord) {
          // 改时区
          const beforeTZIndex = v.statusByte1
          const afterTZIndex = v.statusByte0
          const beforeTZOffset = _getUTCOffset(beforeTZIndex)
          const afterTZOffset = _getUTCOffset(afterTZIndex)
          derror(`beforeTZOffset: ${beforeTZOffset}, afterTZOffset: ${afterTZOffset}`)
          const before = `${this.$t('UTC')}${beforeTZOffset >= 0 ? '+' : ''}${beforeTZOffset}`
          const after = `${this.$t('UTC')}${afterTZOffset >= 0 ? '+' : ''}${afterTZOffset}`
          const t = dayjs(v.dateTimeStr)
          
          const extra = `${before}->${after}`
          return [
            +t,
            _eventDatasHeight,
            'clock',
            extra
          ]
        } else {
          // 改时间
          const beforeHour = v.statusByte1
          const beforeMinute = v.statusByte0
          const beforeMD = `${v.statusShort0}`
          const beforeDay = beforeMD.substr(-2)
          const beforeMonth = beforeMD.substr(0, beforeMD.length - 2)
          const before = `${padZero(beforeMonth)}/${beforeDay} ${padZero(beforeHour)}:${padZero(beforeMinute)}`
          // const after = dayjs(v.dateTimeStr).format('HH:mm')
          const after = dayjs(v.dateTime).format('MM/DD HH:mm')
          
          const extra = `${before}->${after}`
          return [
            +dayjs(v.dateTimeStr),
            _eventDatasHeight,
            'clock',
            extra
          ] 
        }
      })
      
      const rst = {
        name: 'pumpClocks',
        type: 'line',
        showBackground: true,
        lineStyle: {
          width: 0
        },
        label: {
          show: true,
          position: 'right',
          distance: 3,
          formatter: (params) => {
            return ''
            // const { data = [] } = params
            // const l = data[3] || ''
            // return l
          }
        },
        showSymbol: true,
        symbol: (value, params) => {
          const eventType = value[2]
          const symbol = pumpGetSymbol(eventType)
          return symbol
        },
        symbolSize: 20 * _eventIconRatio,
        smooth: true,
        data: _eventDatas
      }
      return [rst]
    },
    getPumpUploadSeries() {
      const events = this.getEventDatas()
      const _eventDatas = events.filter(arr => arr[2] === 'upload')
      
      const rst = {
        name: 'pumpUploads',
        type: 'line',
        showBackground: true,
        lineStyle: {
          width: 0
        },
        label: {
          show: true,
          position: 'right',
          distance: 3,
          formatter: (params) => {
            const { data = [] } = params
            const l = data[3] || ''
            return l
          }
        },
        showSymbol: true,
        symbol: (value, params) => {
          const eventType = value[2]
          const symbol = pumpGetSymbol(eventType)
          return symbol
        },
        symbolSize: 20,
        smooth: true,
        data: _eventDatas
      }
      return [rst]
    },
    getBasalChangeSeries() {
      const { lfs } = this
      const { changeModules: changes } = this
      const _eventDatas = changes ? changes.map((v, i) => {
        return [
          +dayjs(v.dateTimeStr),
          2.5,
          i + 1 // 第几次切换
        ]
      }) : []
      
      const rst = {
        name: 'pumpChangeModules',
        type: 'line',
        yAxisIndex: 0,
        showSymbol: true,
        symboleKeepAspect: true,
        // symbolSize: 60 * _eventIconRatio,
        symbolSize: 20 * _eventIconRatio,
        symbolOffset: [0, '-50%'],
        label: {
          show: true,
          position: 'top',
          color: 'black',
          offset: [0, lfs * 1.5],
          formatter: (params) => {
            const { data } = params
            const what = data[2]
            return what
          }
        },
        markLine: {
          // symbol: 'none',
          symbolSize: 0,
          silent: true,
          lineStyle: {
            // color: '#333',
            color: 'black', // #333: rgb(51, 51, 51)
            type: 'solid',
            width: '1'
          },
          data: _eventDatas.map(arr => {
            const [x, y] = arr
            return [
              {
                coord: [x, 0]
              },
              {
                coord: [x, y]
              }
            ]
          })
        },
        symbol: pumpGetSymbol('changeModule'),
        lineStyle: {
          width: 0
        },
        data: _eventDatas
      }
      return [rst]
    },
    getDeadlineGaps(date) {
      const { allDeadlineGaps } = this
      
      if (date) {
        // if (`${date}` === '2023-05-06') {
        //   debugger
        // }
        const ddate = dayjs(date)
        const st = +ddate
        const et = (+ddate.add(1, 'day')) - 1
        
        const rst = []
        allDeadlineGaps.forEach(gap => {
          const [t0, t1] = gap
          const notInDate = (t1 - st < 0) || (t0 - et > 0)
          if (!notInDate) { // 在date时间范围内
            const start = Math.max(t0, st)
            const end = Math.min(t1, et)
            rst.push([start, end])
          }
        })
        
        derror(`getDeadlineGaps, date: ${date} , rst `, rst.map(gap => [dayjs(gap[0]).format('MM/DD HH:mm'), dayjs(gap[1]).format('MM/DD HH:mm')]))
        return rst
      } else {
        derror(`getDeadlineGaps, date: ${date}, 返回所有的`)
        return allDeadlineGaps
      }
    },
    getBigDosageSeries() { // 获取大剂量的矩形图
      const { lfw, lfs, bigDosage, bigDosageMerged, bigDosageMinWidthMinutes, bigDosageTypeColorsLinear, bigDosageTypeColors } = this
      const _bigDosageTypeColorsLinearOpacityStart = 0.2
      const _bigDosageTypeColorsLinearOpacityGap = 1 - _bigDosageTypeColorsLinearOpacityStart
      const _bigDosageTypeColorsLinear = bigDosageTypeColorsLinear
      const _bigDosageTypeColors = bigDosageTypeColors
      
      const duals = bigDosageMerged.filter(r => `${_getType(r)}` === '2') // 过滤出双波大剂量
      const dualIndexes = duals.reduce((rst, cur) => {
        const arr = cur['indexes'].split(',')
        rst.push(...arr)
        return rst
      }, [])
      console.error(`dualIndexes: `, dualIndexes)
      
      const rst = []
      const _types = ['2', '1', '0']
      // const _types = ['1']
      rst.push(..._types.map(t => {
        let data = []
        if (`${t}` !== '2') {
          // 不是双波
          data = bigDosage.filter(r => `${_getType(r)}` === t && !dualIndexes.includes(`${r['index']}`)) // 根据t过滤
        } else {
          // 获取双波的records的data
          data = bigDosage.filter(r => {
            const i = r['index']
            
            if (i === undefined) {
              derror(`[致命错误]过滤大剂量数据时候，发现没有index字段，这不允许，因为这样的话，我们就无法判断是否是双波`)              
            }
            return dualIndexes.includes(`${i}`)
          }) // 根据t过滤
        }
        
        const opt = _factory(data, t)
        return opt
      }))
      derror(`getBigDosageSeries, rst: `, rst)
      return rst
      
      function _getType(r) {
        return getBigDosageType(r)
      }
      function _factory(data = [], type = '0') { // type 0: 立即大剂量(普通量)、1: 延长大剂量、 2: 双波大剂量
        const _isDual = `${type}` === '2'
        const opt = { // 大剂量
          name: '大剂量type' + type,
          type: 'line',
          yAxisIndex: 0,
          // data: bigDosage,
          symbol: 'none',
          lineStyle: {
            width: 0
          },
          borderRadius: [20, 20, 0, 0],
          barBorderRadius: [20, 20, 0, 0],
          markArea: {
            silent: true, // not responding to mouse events
            borderRadius: [20, 20, 0, 0],
            barBorderRadius: [20, 20, 0, 0],
            label: {
              show: true,
              position: 'top',
              align: 'left',
              // borderColor: 'red',
              // borderWidth: 1,
              textStyle: {
                strokeWidth: 4, // 文案的描边
                stroke: 'red',
                // textShadowColor: 'red',
                // textShadowBlur: 1
              },
              rich: {
                v: {
                  fontSize: labelSize,
                  align: 'left',
                  backgroundColor: `transparent`
                },
                bg: {
                  backgroundColor: `rgba(${bigDosageTypeColorsLinear[type]['r']}, ${bigDosageTypeColorsLinear[type]['g']}, ${bigDosageTypeColorsLinear[type]['b']}, 0.8)`,
                  color: 'white',
                  fontSize: labelSize * 0.8,
                  // padding: [0.1 * lfs, 0.6 * lfs, 0.6 * lfs, 0.1 * lfs],
                  padding: [0.1 * lfs, 0.2 * lfs],
                  align: 'left',
                  borderRadius: 0.1 * lfs
                }
              },
              formatter: (params) => {
                derror(`markaread formatter: `, params)
                const { data = {}} = params
                const { tv, td, ds } = data // tv: true value;td: true duration;ds: dont show
                // return 'haha'
                if (ds) {
                  // dont show
                  return ``
                } else {
                  if (!td) {
                    // 没有持续时间
                    return `{v|${tv}}`
                  } else {
                    return `{v|${tv}}\n{bg|${td}}`                    
                  }
                }
              }
            },
            // itemStyle: {
            //   color: _bigDosageTypeColors[type]
            //   // color: 'white',
            //   // borderColor: '#2d8e2d',
            //   // borderWidth: 2
            // },
            itemStyle: {
              borderJoin: 'round',
              borderRadius: [20, 20, 0, 0],
              barBorderRadius: [20, 20, 0, 0],
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: `rgba(${_bigDosageTypeColorsLinear[type]['r']}, ${_bigDosageTypeColorsLinear[type]['g']}, ${_bigDosageTypeColorsLinear[type]['b']}, 1)` },
                  { offset: 1, color: `rgba(${_bigDosageTypeColorsLinear[type]['r']}, ${_bigDosageTypeColorsLinear[type]['g']}, ${_bigDosageTypeColorsLinear[type]['b']}, ${_bigDosageTypeColorsLinearOpacityStart})` }
                ]
                // colorStops: [
                //   { offset: 1, color: `rgba(${_bigDosageTypeColorsLinear[type]['r']}, ${_bigDosageTypeColorsLinear[type]['g']}, ${_bigDosageTypeColorsLinear[type]['b']}, 1)` },
                //   { offset: 0.76, color: `rgba(${_bigDosageTypeColorsLinear[type]['r']}, ${_bigDosageTypeColorsLinear[type]['g']}, ${_bigDosageTypeColorsLinear[type]['b']}, ${1 - _bigDosageTypeColorsLinearOpacityGap * 0.1}` },
                //   { offset: 0, color: `rgba(${_bigDosageTypeColorsLinear[type]['r']}, ${_bigDosageTypeColorsLinear[type]['g']}, ${_bigDosageTypeColorsLinear[type]['b']}, ${_bigDosageTypeColorsLinearOpacityStart})` }
                // ]
              },
            },
            data: (data.map(c => {
              // 这个data没有合并，所以type都是1和0,不会有双波的type: 2
              const { duration, duration4ui, data, type: ct, extendIdFirstOne } = c
              const type = `${ct}`.trim()
              const isExtended = type === '1' // 延长大剂量
              const isSplitedExtend = isExtended && c.extendId && !c.groupId // 同一个延长量，可能中途会打多个立即大剂量，从而被分割成多段
              const isDualSplitedExtend = isExtended && c.extendId && c.groupId
              // const isDual = type === '2' // 双波
              let extendDurationTxt = ''
              
              if (isExtended) {
                // const durationH = duration / (1000 * 3600)
                const { trueDuration, groupId, extendId } = c
                if (trueDuration === undefined) {
                  extendDurationTxt = `${_tempBasalDuration(duration / 1000)}`
                  console.error(`[补充逻辑]大剂量数据应该有新的字段trueDuration,这是在reportHelper/_getPumpBigDosageFromRecords里头加入的字段;没有的话，需要逻辑需要更新，将其逻辑补上, c: `, c)
                } else {
                  extendDurationTxt = `${_tempBasalDuration(trueDuration / 1000)}`
                  if (trueDuration && trueDuration - (bigDosageMinWidthMinutes * 1000 * 60) < 0) {
                    console.error(`此记录画的时候持续时间是duration: ${duration},但实际的true duration(转化成s)是:${trueDuration / 1000}, record: `, c)
                  }               
                }
                
                // if (extendId && !extendIdFirstOne) {
                if (isSplitedExtend) {
                  // 不展示label;通过merged的bigDosage来展示.有extendId，就说明这个延长大剂量，至少被分成了2个records
                  derror(`不展示label;通过merged的bigDosage来展示.有extendId且没有groupId，就说明这个延长大剂量不属于双波并至少被分成了2个records,不显示label,该label通过_createVerticalDashLineWithBigDosage来显示. bigDosage: `, c)
                  extendDurationTxt = `${_tempBasalDuration(trueDuration / 1000)}`
                }
              }
              
              // name = `` // dev, mock ,test
              
              // const dev = `${data}` === '0.025'
              // if (dev) {
              //   console.error(`0.025的记录修改后的obj: `, c)
              // }
              
              // if (isExtended) {
              //   console.error(`isSplitedExtend: ${isSplitedExtend} c.data: ${c.data}, c.totalBolus: ${c.totalBolus}, check_time: ${dayjs(c.check_time).format('YYYY-MM-DD HH:mm')}`)
              // }
              
              const rst = [
                {
                  xAxis: +dayjs(c.check_time),
                  yAxis: 0
                },
                {
                  xAxis: +dayjs(c.check_time).add(Math.floor(c.duration / 1000), 'second'),
                  yAxis: _transferBigDosageBarData(getBigDosageData(c, true)),
                  tv: getBigDosageData(c, true),
                  td: extendDurationTxt,
                  ds: isSplitedExtend
                }
              ]
              if (isSplitedExtend || isDualSplitedExtend) {
                if (extendIdFirstOne) {
                  rst[1]['xAxis'] = +dayjs(c.check_time).add(Math.floor(c.duration4ui / 1000), 'second')
                  const tv = getBigDosageData(c, false)
                  // if (isDualSplitedExtend) {
                  //   debugger
                  // }
                  Object.assign(rst[1], {
                    yAxis: _transferBigDosageBarData(tv),
                    tv,
                    td: `${_tempBasalDuration(c.totalDuration / 1000)}`
                  })
                } else {
                  return undefined // 不画bigDosage的柱子
                }
              }
              return rst
            })).filter(v => v)
          }
        }
        
        return opt
      }
    },
    getBasalSeries() { // 获取基础率的矩形表格效果图
      const { value, lfs, basalRateInfoMsg, lastUploadTime } = this
      const { threeChartData = {}, date, otherData = [] } = value
      const { insulinChart = {}} = threeChartData
      const { list: pumpRecord } = insulinChart
      const startOfDate = dayjs(date)
      const endOfDate = startOfDate.add(1, 'day') - 1
      const endOfDateT = +endOfDate
      const nowT = dayjs()
      const startOfDateT = +startOfDate
      
      const _basals_withoutAppendTwoPoints = _getPumpBasalFromRecords(pumpRecord)
      const _basals = _appendTwoPointsToBasals(date, _basals_withoutAppendTwoPoints, this.getDeadlineGaps(), this.yesterday, lastUploadTime)
      const _showLabelBasals = _getPumpBasalShouldShowLabelRecordsFromBasals(_basals)
      // /* *********临时基础率发生的时间点********* */
      // const _tempBasalTimes = (otherData.filter(_otherDataGetTempBasalFilter)).map(obj => +dayjs(obj.dateTimeStr))
      // /* *********End of 临时基础率发生的时间点********* */
      let basals = []
      // 改变数据结构，用来给echarts渲染
      basals = _basals.map(v => {
        const [v1, v2, ...rest] = v || []
        return [
          v1,
          _transferBasalData(v2),
          ...rest,
          `orin-${v2}`
        ]
      })
      // if (basals.length && nowT - endOfDateT < 0) { // date是今天，并且今天还没运行完(即没到23:59:59)
      //   const last = basals[basals.length - 1]
      //   const [t, v, isAppend, ...rest] = last
      //   if (isAppend) { // 认为最后一条是插入的数据，那么修改这条数据截止时间到nowT
      //     last[0] = +nowT
      //   }
      // }
      
      const arr = [] // 返回值
      
      // 生成基础率红线的series
      const gapsUnique = this.getDeadlineGaps(date)
      if (gapsUnique.length) {
        // 制作'画红线的series'
        const datas = []
        gapsUnique.forEach(gap => {
          datas.push(gap.map((t, i) => {
            const _beforeDate = t - startOfDateT < 0
            const _afterEnd = t - lastUploadTime >= 0
            const _dateIsAfterEnd = lastUploadTime - startOfDateT < 0
            const _nowIsInDate = dayjs().format('YYYY-MM-DD') === `${date}`
            
            if (i >= 1) {
              // gap end point
              if (_afterEnd) {
                if (_dateIsAfterEnd) {
                  error(`[逻辑黑洞]最后一次上传时间lastUploadTime: ${lastUploadTime}(${dayjs(lastUploadTime).format('YYYY-MM-DD HH:mm:ss')}), 是在今天${date}之前。这是有问题的。会导致逻辑有误`)
                  return [t, 0]
                } else {
                  if (_nowIsInDate) {
                    return [lastUploadTime, 0]                                      
                  } else {
                    return [t, 0]
                  }
                }
              } else {
                return [t, 0]
              }
            } else {
              // gap start point
              if (_beforeDate) {
                return [startOfDateT, 0]
              } else {
                return [t, 0]
              }
            }
          }))
        })
        derror(`gaps转换出来的datas`, datas)
        
        datas.forEach(data => {
          arr.push({
            type: 'line',
            data,
            lineStyle: {
              width: 2,
              color: 'red'
            },
            symbol: 'none',
            smooth: true
          })
        })                
      }
      
      const rst = { // 矩形输注图;基础率
        z: -1,
        yAxisIndex: 1, // 右侧坐标轴
        name: 'area-line',
        type: 'line',
        step: 'end',
        silent: true,
        label: { // tbc:label得换成新的series去计算，否则无非做到放到矩形的正中间(好像改成step: middle就行了)
          show: true,
          fontSize: labelSize,
          position: 'top',
          align: 'center',
          verticalAlign: 'bottom',
          distance: (8 / 12) * lfs,
          offset: [0, 0],
          formatter: (params = {}) => {
            return ''
          },
          color: this.basalC
        },
        lineStyle: {
          show: true,
          width: 2,
          // color: '#00BAFF'
          color: this.basalBorderC
        },
        areaStyle: {
          emphasis: {
            disabled: true
          }, // 禁用停留高亮
          opacity: 0.2,
          color: this.basalC
        },
        symbolSize: 0,
        data: basals
      }
      
      arr.push(rst)
      return arr
      
      function _sameObj(v, compareToMeObj) {
        let same = false
        if (v && compareToMeObj) {
          same = v[0] && compareToMeObj[0] && +v[0] === +compareToMeObj[0]
        }
        return same
      }      
    },
    getMealLabelGraphics() {
      const { cmax, cmin, lfw, lfs, unit, value, isFirst, isLast, w } = this      
      const uiP = this.getUiParams()
      const {
        mealLabelOffsetY, mealLabelOffsetH, mealLabelOffsets
      } = uiP
      
      const grid = this.getCommonGridOpt()
      let { mealLabelOffsetX, oneHourW } = uiP
      
      if (isFirst && isLast) {
        oneHourW = ((366 / 24) / 459.6) * w // 具体渲染出来的        
        mealLabelOffsetX = grid.left
      } else if (isFirst) {
        mealLabelOffsetX = grid.left + oneHourW * 0.5
      } else if (isLast) {
        mealLabelOffsetX = grid.left + oneHourW * 0.5
      } else { // 既不是first,也不是last
        mealLabelOffsetX = grid.left + oneHourW * 0.5
      }
      // if (isLast) {
      
      // }
      
      const largerRatio = 10 / 12
      
      const arr = [
        {
          type: 'group',
          id: 'breakfast_label',
          bounding: 'all',
          top: mealLabelOffsetY,
          left: mealLabelOffsets.breakfast.start * oneHourW + mealLabelOffsetX,
          z: 100,
          children: [              
            {
              type: 'text',
              left: 'center',
              top: 'center',
              id: 'label_text',
              z: 100,
              style: {
                fill: _mealLabelColor,
                text: this.$t('Breakfast'),
                font: `bold ${lfs * largerRatio}px sans-serif`
              }
            }
          ]
        },
        {
          type: 'group',
          bounding: 'all',
          top: mealLabelOffsetY,
          left: mealLabelOffsets.lunch.start * oneHourW + mealLabelOffsetX,
          z: 100,
          children: [
            {
              type: 'text',
              left: 'center',
              top: 'center',
              z: 100,
              style: {
                fill: _mealLabelColor,
                text: this.$t('Lunch'),
                font: `bold ${lfs * largerRatio}px sans-serif`
              }
            }
          ]
        },
        {
          type: 'group',
          bounding: 'all',
          top: mealLabelOffsetY,
          left: mealLabelOffsets.supper.start * oneHourW + mealLabelOffsetX,
          z: 100,
          children: [
            {
              type: 'text',
              left: 'center',
              top: 'center',
              z: 100,
              style: {
                fill: _mealLabelColor,
                text: this.$t('Supper'),
                font: `bold ${lfs * largerRatio}px sans-serif`
              }
            }
          ]
        }
      ]
      return arr
    },
    getMealBgHighlight() {
      const {
        mealLabelOffsets
      } = this.getUiParams()
      const { value } = this
      const { date } = value
      const startOfDay = dayjs(date).startOf('day')
      const arr = []
      arr.push({ // 高亮早、中、晚餐部分
        name: '高亮三餐',
        type: 'line',
        data: [],
        lineStyle: {
          width: 2
        },
        symbol: 'none',
        smooth: true,
        markArea: {
          itemStyle: {
            color: _mealBg,
            borderColor: '#abccba',
            borderWidth: 0
          },
          data: [
            [{ xAxis: +startOfDay.add(mealLabelOffsets.breakfast.start, 'hour') }, { xAxis: +startOfDay.add((+mealLabelOffsets.breakfast.start + +mealLabelOffsets.breakfast.duration), 'hour') }],
            [{ xAxis: +startOfDay.add(mealLabelOffsets.lunch.start, 'hour') }, { xAxis: +startOfDay.add((+mealLabelOffsets.lunch.start + +mealLabelOffsets.lunch.duration), 'hour') }],
            [{ xAxis: +startOfDay.add(mealLabelOffsets.supper.start, 'hour') }, { xAxis: +startOfDay.add((+mealLabelOffsets.supper.start + +mealLabelOffsets.supper.duration), 'hour') }]
          ]
        }
      })
      return arr
    },
    getExtendBigDosageVerticalSplitLabels(extendDosages = [], hasLabel = false) {
      return _createVerticalDashLineWithSplitedExtendedBigDosageLabelCfg(extendDosages, this)
    },
    getBigDosageVerticalSplitLineSeries(bigDosageMerged, hasLabel = false) {
      return [
        {
          name: '大剂量-分割线',
          type: 'line',
          yAxisIndex: 0,
          // data: bigDosage,
          symbol: 'none',
          lineStyle: {
            width: 0
          },
          markLine: {
            silent: true,
            symbol: 'none',
            data: _createVerticalDashLineWithBigDosage(bigDosageMerged, this, hasLabel)
          }
        }
      ]
    },
    getImmediateBigDosageSeries() { // 不展示needle.ChartDailyPump组件已经展示needle了，这个组件暂时不展示。因为这个组件长宽比较小，所以不清楚产品经理是否要展示。而此时产品经理又请假不在.
      const { value, lfs, quickPumpTagList = [], bigDosageMerged = [] } = this
      const { date } = value
      
      if (!quickPumpTagList.length || !bigDosageMerged.length) {
        return []
      }
      
      const dfmt = 'YYYY-MM-DD'
      const currentDateQuickPumps = quickPumpTagList.filter(obj => {
        return dayjs(date).format(dfmt) === dayjs(obj.dateTimeStr).format(dfmt)
      })
      
      const buffer = 60 // 秒为单位;这个buffer用来寻找根据 quickPumpTagList的时间戳，找到到对应的大剂量记录(前后浮动{buffer}时长)
      
      const _eventDatas = (currentDateQuickPumps.map((obj, i) => {
        const time = obj.dateTimeStr
        
        const respectBigDosageIndex = findObjIndexInArray(bigDosageMerged, { check_time: time }, function _sameTime(v, compareToMeObj) {
          let same = false
          
          const t1 = dayjs(v['check_time'])
          const t2 = dayjs(compareToMeObj['check_time'])
          
          if (Math.abs(t1 - t2) - buffer * 1000 <= 0) {
            same = true
          }
          
          return same
        })
        
        if (respectBigDosageIndex < 0) {
          error(`[接口数据返回有问题但逻辑不会崩]，字段quickPumpTagList的${i}下标的值，其dateTimeStr: ${time}。理论上应该在bigDosageMerged里头应该能找到一条记录记录，其check_time在${time}的前后1分钟. bigDosageMerged: `, bigDosageMerged)
          return undefined
        }
        
        const dosage = bigDosageMerged[respectBigDosageIndex]
        
        return [
          +dayjs(time),
          _transferBigDosageBarData(dosage.data),
          'needle'
        ]
      })).filter(v => !!v)
      
      const rst = {
        name: 'pumpImmediateBigDosages',
        type: 'line',
        showBackground: true,
        lineStyle: {
          width: 0
        },
        showSymbol: true,
        symbolOffset: ['-25%', '-40%'],
        symbol: (value, params) => {
          const eventType = value[2]
          const symbol = pumpGetSymbol(eventType)
          return symbol
        },
        symbolSize: 20 * _eventIconRatio,
        smooth: true,
        data: _eventDatas
      }
      return [rst]
    },
    pumpSeriesFromDataSource(what) {
      const { cmax, cmin, stripeBgC, stripeInnerBorderC, lfw, lfs, largerRatio, unit, ds, value, bigDosage, bigDosageMerged } = this
      
      const series = [
        ...this.getBasalSeries(),
        ...this.getReservoirChangeSeries(), // 底版更换图标
        ...this.getPumpAlarmSeries(), // alarm图标
        ...this.getPumpClockSeries(), // clock图标
        ...this.getPumpUploadSeries(), // upload图标
        ...this.getBasalChangeSeries(), // 基础率设置切换图标
        ...this.getImmediateBigDosageSeries(), // 立即大剂量的图标(针头)
        ...this.getBigDosageSeries(), // 获取大剂量的矩形图
        ...this.getBigDosageVerticalSplitLineSeries(bigDosageMerged, true),
        ...this.getExtendBigDosageVerticalSplitLabels(bigDosageMerged.filter(r => { // 保留非双波的、被分割成多条记录的延长大剂量
          const { extendId, groupId, type } = r
          return `${type}` === '1' && !groupId && extendId
        }), true),
        // { // 模块1变换成模块2
        //   name: '模块change',
        //   type: 'line',
        //   yAxisIndex: 0,
        //   data: [[1677566593461, 0, 1], [1677552193461, 0, 0], [1677537793461, 0, 0]],
        //   showSymbol: true,
        //   symboleKeepAspect: true,
        //   symbolSize: 60,
        //   symbolOffset: [0, '-50%'],
        //   label: {
        //     show: true,
        //     position: 'top',
        //     color: 'black',
        //     offset: [0, lfs * 1.5],
        //     formatter: (params) => {
        //       const { data } = params
        //       const what = data[2]
        
        //       if (what) {
        //         // 模块1变模块2
        //         return 1
        //       } else {
        //         // 模块2变模块1
        //         return 2
        //       }
        //     }
        //   },
        //   symbol: pumpGetSymbol('changeModule'),
        //   lineStyle: {
        //     width: 1
        //   }
        // }
      ]
      derror(`${what},series: `, series)
      
      return series
    },
    getGrid(what = 'top', orin = {}) {
      const { isFirst, lfs, isLast, h, dateDivH } = this
      const rst = orin
      
      if (what === 'top') {
        rst.bottom = 0
        // rst.top = lfs * 4.5
        const topPad = 0.2 * lfs
        rst.top = 1.05 * lfs + topPad// 29是显示日期的那个div高度；72是日期+这个三餐label的总高度
        
        // rst.bottom = 20
        // rst.top = 20
      }
      
      if (what === 'middle') {
        rst.top = 0
        rst.bottom = 1 // 留一个bottom从而能显示出x轴
      }
      
      if (what === 'bottom') {
        rst.bottom = lfs * 2
        rst.top = 0
      }
      
      // derror(`[[[[]]]], ${what}, getGrid, rst`, rst)
      return rst
    },
    getCommonXAxis(date) { // 因为不是底部的echarts由于bottom为0，所以x轴没画出来
      const { lfs, isFirst, isLast } = this
      const $start = date ? dayjs(date) : dayjs().startOf('day')
      const $end = $start.add(1, 'day').startOf('day')
      return [
        {
          boundaryGap: false,
          type: 'time',
          position: 'bottom',
          splitLine: {
            show: false
          },
          min: +$start,
          max: +$end,
          splitNumber: 24,
          // minInterval: 1,
          axisLine: {
            show: true,
            lineStyle: {
              color: _axisLineColor
            },
          },
          axisTick: {
            show: true,
            lineStyle: {
              color: _axisLabelColor,
            }
          },
          minorTick: {
            show: true
          },
          axisLabel: {
            show: true,
            showMaxLabel: false,
            color: _axisLabelColor,
            fontWeight: 800,
            fontSize: (18 / 12) * lfs,
            formatter: (v, i) => { // i从1开始
              const _showIs = [1, 7, 13, 19, 24] // 0:00, 6:00, 12:00, 18:00
              if (_showIs.includes(i)) {
                if (i === 1) {
                  // return dayjs(v).format('mm')
                  if (isFirst) {
                    return '00:00'
                  } else {
                    return '    00'
                  }
                }
                if (i === 24) { // 和下一个拼凑出一整个00:00
                  if (isLast) {
                    return '24:00'
                  } else {
                    return ' 00:'                    
                  }
                }
                return dayjs(v).format('HH:mm')                
              } else {
                return ''
              }
            }
          }
        }
      ]
    },
    getCommonGridOpt() {
      const { lfs, trueW, ds, isFirst, isLast, isLongLanguage } = this
      
      const grid = {
        right: 0,
        bottom: 0,
        left: isLongLanguage ? (lfs * 7.5) : (lfs * 4),
        [isFirst ? '' : 'left']: 0,
        [isLast ? 'right' : '']: lfs * 4.3
      }
      
      const width24Hour = trueW
      const oneHourW = width24Hour / 24
      
      return Object.assign({}, grid, {
        oneHourW, width24Hour
      })
    },
    refreshTriggered() {
      derror(`pumpOneDayGrah ${this.id}, this.refreshTriggered`)
      this.render(true)
    },
    render(isUpdate = false) {
      derror(`render, isUpdate: ${isUpdate}`)
      if (!isUpdate) {
        this.initChart()
      } else {
        this.updateChart()
      }
    },
    getUiParams() { // 修改配置在这里(数据层面更改后，会修改到这里返回逻辑)
      const r = 4
      const { lfw, lfs, ds, setting, dateDivH } = this
      const oneHourW = (40 / 1200 * ds) / r
      const mealLabelOffsetX = ((120 / 1200) * ds) / r
      const mealLabelOffsetH = (4.2 * lfs) / r
      const mealLabelOffsetY = (48.5 - dateDivH - mealLabelOffsetH) / 1 // dateDivH是日期文案的高度
      const mealLabelOffsets = { // 会影响到到给矩形的三餐label做圆角的逻辑
        breakfast: {
          start: 5, // 5:00开始进食;可以是小数
          duration: 4 // 持续4小时;可以是小数
        },
        lunch: {
          start: 12, // 12:00开始进食
          duration: 2
        },
        supper: {
          start: 17, // 17:00开始进食
          duration: 5
        }
      }
      
      if (setting && setting.settingId !== undefined) {
        const { breakfastTime, supperTime, lunchTime } = setting
        
        if (breakfastTime) {
          const arr = breakfastTime.split(',')
          const _now = dayjs()
          const startOfDay = _now.startOf('day')
          
          const _start = dayjs(`${_now.format('YYYY-MM-DD')} ${arr[0]}`)
          const _end = dayjs(`${_now.format('YYYY-MM-DD')} ${arr[1]}`)
          const duration = (_end - _start) / (1000 * 60 * 60)
          const start = (_start - startOfDay) / (1000 * 60 * 60)
          
          Object.assign(mealLabelOffsets.breakfast, {
            start, duration
          })
        }
        
        if (lunchTime) {
          const arr = lunchTime.split(',')
          const _now = dayjs()
          const startOfDay = _now.startOf('day')
          
          const _start = dayjs(`${_now.format('YYYY-MM-DD')} ${arr[0]}`)
          const _end = dayjs(`${_now.format('YYYY-MM-DD')} ${arr[1]}`)
          const duration = (_end - _start) / (1000 * 60 * 60)
          const start = (_start - startOfDay) / (1000 * 60 * 60)
          
          Object.assign(mealLabelOffsets.lunch, {
            start, duration
          })
        }
        if (supperTime) {
          const arr = supperTime.split(',')
          const _now = dayjs()
          const startOfDay = _now.startOf('day')
          
          const _start = dayjs(`${_now.format('YYYY-MM-DD')} ${arr[0]}`)
          const _end = dayjs(`${_now.format('YYYY-MM-DD')} ${arr[1]}`)
          const duration = (_end - _start) / (1000 * 60 * 60)
          const start = (_start - startOfDay) / (1000 * 60 * 60)
          
          Object.assign(mealLabelOffsets.supper, {
            start, duration
          })
        }
      }

      // // dev,修改三餐
      // mealLabelOffsets.breakfast.duration = 1
      // mealLabelOffsets.lunch.duration = 1
      // mealLabelOffsets.supper.duration = 1
      // // End dev,修改三餐
      
      const rst = {
        oneHourW, mealLabelOffsetX, mealLabelOffsetY, mealLabelOffsetH, mealLabelOffsets
      }
      // derror(`getUiParams mealLabelOffsetY: ${mealLabelOffsetY}`)
      return rst
    },
    getOpt() {
      const { cmax, cmin, lfw, lfs, unit, isFirst, isLast, bigDosage, bigDosageMerged, value, unitRatio, stripeInnerBorderC, noHorizontalSplitLine, noMealHighlight, isUnitMg } = this
      const { cmaxC, cminC, normalC } = this
      const { date } = value
      const startOfDay = dayjs(date).startOf('day')      
      
      const xAxis = [
        ...this.getCommonXAxis(date)
      ]
      
      // x轴去掉label之类的，从而能当做正常的"底部border"来显示;底部border是通过grid.bottom为1或0，从而让x轴能渲染(当做border)或者在画布外渲染(从而无border)
      do {
        const x = xAxis[0]
        x.axisTick.show = false
        x.minorTick.show = false
        x.axisLabel.show = false
        // eslint-disable-next-line
      } while (false)

      if (noHorizontalSplitLine) { // 画一个顶部的线，从而有border效果
        xAxis.push({
          type: 'time',
          position: 'top',
          splitLine: {
            show: false
          },
          axisLine: {
            onZero: false, // 默认是true,会导致position: top无效，一直显示在底部
            show: true,
            lineStyle: {
              color: _axisLineColor
            },
          },
          axisLabel: {
            show: false,
            showMaxLabel: false
          },
          axisTick: {
            show: false,
            lineStyle: {
              color: 'red'
            }
          },
          minorTick: {
            show: false
          }
        })
      }
      
      derror(`xAxis, `, xAxis)
      
      const { bloodGlucoseRecord = [], threeChartData = {}} = value
      const { cgmRecordList = [] } = threeChartData
      const data = _sortCgmRecordListByTimeAsc(cgmRecordList)
      // 生成series
      const afterD = _dataConverter(data) // value是已经_transferBGData的y值.真实的数据在truev字段
      // derror(`data `, data)
      // derror(`after data `, afterD)
      
      let _gluAreaSeriesOpt
      if (afterD && afterD.length === 0) {
        // 压入一个占位数据，否则整个表格一片白
        // derror(`压入一个占位数据，否则整个表格一片白`)
        // afterD.push([+(dayjs(date).add(3, 'hour')), cmax + 0.1, undefined, true]) // 数值必须大于cmax,这样子才能将2条分界线渲染出来(这可能是因为我yaxis没有设置max的原因导致的?)
        _gluAreaSeriesOpt = []
      } else {
        _gluAreaSeriesOpt = _createLineAreaWithDiffentColor(afterD, this) // 修改此处，此处是生成area范围(不同颜色)的配置。// 它是把一条线，根据值的大小，分成多个对象，每个对象对应一段颜色
      }
      
      const _gluDatas = _dataConverter2(bloodGlucoseRecord) // BG血糖(指血值，非cgms)
      // // startof mock,dev,test
      // const limits = [25, 20, 18, 15, 10, 5, 3.9, 3, 1, 0].map(v => (v * (isUnitMg ? 18 : 1)))
      // // eslint-disable-next-line
      // ;limits.forEach(v => {
      //   console.error(`_gluDatas推入v: ${v}`)
      //   _gluDatas.push([+(dayjs(date).add(3, 'hour')), _transferBGData(v, isUnitMg), 0, v]) // test,dev,mock
      // })
      // // endof mock,dev,test
      
      const _gluSeries = [{ // BG血糖的线
        type: 'line',
        name: 'bgvalue-noline',
        data: _gluDatas,
        symbol: '',
        symbolSize: 8,
        label: {
          show: true,
          color: stripeInnerBorderC,
          fontSize: lfs,
          align: 'center',
          position: 'top',
          formatter: (params = {}) => {
            const { data = [] } = params
            // derror(`formatter, v: ${JSON.stringify(v)}, params: ${params}`)
            // const v = data[1]
            const truev = data[3]
            return `${truev}`
          }
        },
        lineStyle: {
          width: 0
        },
        itemStyle: {
          color: (params) => {
            const { data = [] } = params || {}
            const v = data[1]
            
            let rst = normalC
            if (isHighGlu(v)) {
              rst = cmaxC
            } else if (isLowGlu(v)) {
              rst = cminC
            }
            return rst
          }
        },
        smooth: true
      }]
      
      const grid = this.getGrid('middle', this.getCommonGridOpt())
      const option = {
        animation: false,
        grid,
        xAxis,
        yAxis: [
          {
            type: 'value',
            min: 0,
            max: 20 * unitRatio,
            splitNumber: 5,
            [isFirst ? 'nameGap' : '']: 15,
            [isFirst ? 'name' : '']: unit,
            nameTextStyle: {
              borderWidth: 1,
              color: _axisLabelColor,
              fontWeight: 800,
              fontSize: (16 / 12) * lfs,
              padding: [0, 0, 0 - 0.4 * lfs, 0 - 1.8 * lfs]
            },
            minorTick: {
              show: false
            },
            splitLine: {
              show: !noHorizontalSplitLine
            },
            axisLine: {
              show: true,
              lineStyle: isFirst ? {
                color: _axisLineColor
              } : {
                width: 2,
                color: 'black'
              }
            },
            axisLabel: {
              margin: 0.8 * lfs,
              show: isFirst,
              showMaxLabel: isFirst,
              color: _axisLabelColor,
              fontWeight: 800,
              fontSize: (18 / 12) * lfs,
              formatter: (...arr) => {
                const v = arr[0]
                const i = arr[1]
                // console.error(`axisLabel formatter`, arr)
                const rst = trimEndZero(`${(_transferYHeightToBGValue(v, isUnitMg)).toFixed((isUnitMg ? 0 : 1))}`)
                return rst
              }
            },
            axisTick: {
              show: false, // 不显示刻度
              lineStyle: {
                color: _axisLabelColor,
              }
            }
          },
          {
            type: 'value',
            min: 0,
            nameGap: 15,
            position: 'left',
            name: `${dayjs(date).format('MM/DD')} ${readableWeek(dayjs(date))}`,
            nameTextStyle: {
              color: 'black',
              fontSize: 18,
              fontWeight: 'bold',
              padding: isFirst ? [3, 4, lfs * 0.8, lfs * 8] : [3, 4, lfs * 0.8, lfs * 15]
            },
            minorTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            splitArea: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              show: false,
              showMaxLabel: false,
              color: '#999',
            },
            axisTick: {
              show: false, // 不显示刻度
            }
          },
          {
            type: 'value',
            min: 0,
            position: 'right',
            minorTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLine: {
              show: isLast,
              lineStyle: {
                width: 1,
                color: _axisLineColor
              }
            },
            axisLabel: {
              show: false,
              showMaxLabel: false,
            },
            axisTick: {
              show: false
            }
          }
        ],
        series: [
          { // 高低血糖的境界的横线
            type: 'line',
            data: [],
            lineStyle: {
              width: 2
            },
            symbol: 'none',
            smooth: true,
            markLine: {
              symbol: 'none',
              data: [
                {
                  silent: true, // 鼠标悬停事件  true没有，false有
                  lineStyle: {
                    type: 'dashed',
                    color: cmaxC,
                    width: 2
                  },
                  label: {
                    show: true,
                    position: 'end',
                    distance: [6, 0],
                    color: cmaxC,
                    formatter: (params) => {
                      return `${cmax}`
                    },
                    fontWeigt: lfw
                  },
                  yAxis: _transferBGData(cmax, isUnitMg) // 警戒线的标注值，可以有多个yAxis,多条警示线   或者采用   {type : 'average', name: '平均值'}，type值有  max  min  average，分为最大，最小，平均值
                },
                {
                  silent: true, // 鼠标悬停事件  true没有，false有
                  lineStyle: {
                    type: 'dashed',
                    color: cminC,
                    width: 2
                  },
                  label: {
                    show: true,
                    position: 'end',
                    distance: [6, 0],
                    color: cminC,
                    formatter: (params) => {
                      return `${cmin}`
                    },
                    fontWeigt: lfw
                  },
                  yAxis: _transferBGData(cmin, isUnitMg)
                }
              ]
            }
          },
        ].concat(_gluAreaSeriesOpt).concat(...this.getBigDosageVerticalSplitLineSeries(bigDosageMerged, false)).concat(..._gluSeries),
      }
      
      if (!noMealHighlight) { // 早、中、晚餐的类似label的东西
        // 需要显示三餐高亮
        // option.graphic = [...this.getMealLabelGraphics()]
        option.series.push(...this.getMealBgHighlight())
      }
      
      // window.o = option
      return option
      
      function _dataConverter(data) { // cgms
        return data.map((d, i) => {
          return {
            time: +dayjs(d.deviceTimeStr),
            value: _transferBGData(d.eventData, isUnitMg),
            truev: d.eventData
          }
        })
      }
      function _dataConverter2(data) { // bg(指血数据点)
        return data.map((d, i) => {
          const v = _transferBGData(+d.bloodGlucose, isUnitMg)
          return [+dayjs(d.testTimeStr), isUnitMg ? (v).toFixed(0) : (v).toFixed(1), d.dataOrigin, d.bloodGlucose]
        })
      }
    },
    getOptIcon() {
      const { cmax, cmin, lfw, lfs, unit, isFirst, isLast, bigDosage, bigDosageMerged, noHorizontalSplitLine, noMealHighlight, isUnitMg } = this
      const { value } = this
      const { date } = value
      const startOfDay = dayjs(date).startOf('day')
      const xAxis = this.getCommonXAxis(date)

      // 去掉xAxis轴下面的axis tick
      try {
        if (xAxis[0]) {
          const axis = xAxis[0]
          axis.axisTick.show = false          
          axis.minorTick.show = false
          axis.axisLabel.show = false
        }
        /* eslint-disable-next-line */
      } catch (error) {
      }
      
      const grid = this.getGrid('top', this.getCommonGridOpt())
      
      // 画一个顶部的线，从而有border效果
      xAxis.push({
        type: 'time',
        position: 'top',
        splitLine: {
          show: false
        },
        axisLine: {
          onZero: false, // 默认是true,会导致position: top无效，一直显示在底部
          show: true,
          lineStyle: {
            color: _axisLineColor
          },
        },
        axisLabel: {
          show: false,
          showMaxLabel: false
        },
        axisTick: {
          show: false,
          lineStyle: {
            color: 'red'
          }
        },
        minorTick: {
          show: false
        }
      })
      
      const _coKey = 'carbsRecord'      
      const _coDatas = value[_coKey].map(v => {
        const rst = [
          +dayjs(v.dateTimeStr),
          this.$t('CO'),
          v.statusShort1
        ]
        return rst
      })
      
      const option = {
        animation: false,
        grid,
        xAxis,
        yAxis: [
          {
            type: 'category',
            data: [
              this.$t('CO')
            ],
            boundaryGap: true,
            [isFirst ? 'nameGap' : '']: (0 - lfs * (9.9 / 12)),
            [isFirst ? 'name' : '']: isUnitMg ? '360' : '20',
            // [isFirst ? 'nameLocation' : '']: 'middle',            
            // [isFirst ? 'nameRotate' : '']: 90,
            nameLocation: 'start',
            nameRotate: 0,
            nameTextStyle: {
              show: true,
              // color: _axisLabelColor,
              // backgroundColor: "rgba(255, 255, 255, 1)",
              color: 'black',
              fontWeight: 800,
              fontSize: (18 / 12) * lfs,
              height: lfs * 4,
              // padding: [0, (28.9 / 12 * lfs), (0 - Math.round(16 / 12 * lfs / 2)), 0] // 上方的半个0
              padding: isUnitMg ? [(0.5 / 12 * lfs), (56.3 / 12 * lfs), 0, 0] : [0, (40.3 / 12 * lfs), 0, 0] // 下方的20,需要配合nameRotate&nameLocation使用
            },
            splitArea: {
              show: false,
              areaStyle: {
                // 使用深浅的间隔色
                color: ['#ccc', 'rgba(255, 223, 192, 1)'],
              }
            },
            splitLine: {
              show: isFirst
            },
            axisLine: {
              show: true,
              lineStyle: isFirst ? {
                color: _axisLineColor
              } : {
                width: 2,
                color: 'black'
              }
            },
            axisLabel: {
              margin: 0.8 * lfs,
              show: isFirst,
              showMaxLabel: isFirst,
              color: _axisLabelColor,
              fontWeight: 800,
              fontSize: (18 / 12) * lfs,
              padding: [0, -0.5 * lfs, 0, 0]
            },
            axisTick: {
              show: isFirst, // 不显示刻度
              lineStyle: {
                color: _axisLabelColor,
              }
            }
          },
          {
            type: 'category',
            position: 'right',
            minorTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLine: {
              show: isLast,
              lineStyle: {
                width: 1,
                color: _axisLineColor
              }
            },
            axisLabel: {
              show: false,
              showMaxLabel: false,
            },
            axisTick: {
              show: false
            }
          }
        ],
        series: [
          {
            name: 'co-line',
            type: 'line',
            lineStyle: {
              show: false,
              width: 0
            },
            label: {
              show: true,
              position: 'right',
              align: 'center',
              color: 'black',
              offset: [-2, 0],
              formatter: (params) => {
                const { data } = params
                return data[2]
              }
            },
            symbolSize: 0,
            data: _coDatas,
          }, ...this.getBigDosageVerticalSplitLineSeries(bigDosageMerged, false)
        ]
      }
      
      if (!noMealHighlight) { // 早、中、晚餐的类似label的东西
        // 需要显示三餐高亮
        option.graphic = [...this.getMealLabelGraphics()]
        option.series.push(...this.getMealBgHighlight())
      }
      
      // window.oi = option
      return option
    },
    getOptBar(what) {
      const { cmax, cmin, lfw, lfs, unit, isFirst, isLast, value, noMealHighlight } = this
      const { date } = value || {}
      
      const grid = this.getGrid('bottom', this.getCommonGridOpt())
      //       const rst = {
      //   right: 0,
      //   bottom: 0,
      //   [isFirst ? '' : 'left']: 0,
      //   [isLast ? 'right' : '']: lfs
      // }
      
      const series = [...(this.pumpSeriesFromDataSource(what))]
      if (!noMealHighlight) { // 早、中、晚餐的类似label的东西
        // 需要显示三餐高亮
        // option.graphic = [...this.getMealLabelGraphics()]
        series.push(...this.getMealBgHighlight())
      }
      
      // const _eventDatas.push([
      //   +dayjs(dtime),
      //   '',
      //   etype
      // ])
      const _eventDatas = []
      
      series.unshift({
        name: 'event-line',
        type: 'line',
        showBackground: true,
        lineStyle: {
          width: 0
        },
        showSymbol: true,
        symbol: (value, params) => {
          const eventType = value[2]
          const symbol = pumpGetSymbol(eventType)
          return symbol
        },
        symbolSize: 20 * _eventIconRatio,
        smooth: true,
        data: _eventDatas
      })
      const xAxis = this.getCommonXAxis(date)
      
      const option = {
        animation: false,
        grid,
        xAxis,
        yAxis: [
          {
            type: 'value',
            min: 0,
            max: 11,
            [isFirst ? 'nameGap' : '']: 0,
            [isFirst ? 'name' : '']: '0',
            'nameTextStyle': {
              show: true,
              color: _axisLabelColor,
              fontWeight: 800,
              fontSize: (18 / 12) * lfs,
              padding: [0, (30 / 12 * lfs), (0 - Math.round(16 / 12 * lfs / 2)), 0]
            },
            splitNumber: 11, // showMaxLabel设置成false，那么只会显示到10;因为maxLabel会显示不全，所以我们这边设置最大成11
            minorTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLine: {
              show: true,
              lineStyle: isFirst ? {
                color: _axisLineColor
              } : {
                width: 2,
                color: 'black'
              }
            },
            axisLabel: {
              margin: 0.8 * lfs,
              show: isFirst,
              showMaxLabel: isFirst,
              // color: _axisLabelColor,
              color: 'black',
              fontWeight: 800,
              fontSize: (18 / 12) * lfs,
              formatter: (value, index) => { // 改变这里逻辑，要对应改变_transferBigDosageBarData
                const shouldShowVs = [0, 5, 10] // 这个是坐标值默认有的坐标值 _transferBigDosageBarData(10)或者_transferBigDosageBarData(11)的值为7； _transferBigDosageBarData(25)的值是10;
                const shouldShowTxts = [0, 5, `25U`] // 分别对应_transferBigDosageBarData(shouldShowTxts[i]) == shouldShowVs[i]
                const i = shouldShowVs.indexOf(+value)
                return i >= 0 ? shouldShowTxts[i] : ''                  
              }
            },
            axisTick: {
              show: isFirst, // 不显示刻度
              lineStyle: {
                color: _axisLabelColor,
              }
            }
          },
          {
            type: 'value',
            min: 0,
            max: 5.5,
            position: 'right',
            splitNumber: 11, // showMaxLabel设置成false，那么只会显示到10;因为maxLabel会显示不全，所以我们这边设置最大成11
            minorTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLine: {
              show: isLast,
              lineStyle: {
                width: 1,
                color: _axisLineColor
              }
            },
            axisLabel: {
              show: isLast,
              showMaxLabel: isLast,
              color: _axisLabelColor,
              fontWeight: 800,
              fontSize: (18 / 12) * lfs,
              formatter: (value, index) => { // 改变这里逻辑，要对应改变_transferBasalData
                // derror(`坐标值, value: ${value}, index: ${index}`)
                const shouldShowVs = [0, 2.5, 5] // 这是坐标值已有的值
                const shouldShowTxts = [0, 2.5, `5U/h`] // _transferBigDosageBarData(shouldShowTxts[i]) == shouldShowVs[i]
                const i = shouldShowVs.indexOf(+value)
                return i >= 0 ? shouldShowTxts[i] : ''
              }
            },
            axisTick: {
              show: isLast,
              lineStyle: {
                color: _axisLabelColor,
              }
            }
          }
        ],
        series
      }
      derror(`bar option`, option)
      // window.obar = option
      return option
    },
    renderZebraBars({ hasInited }) {
      derror(`renderZebraBars, hasInited: ${hasInited}`)
      const { h: height, id, sortedBasalRateBaseSetting = [], basalC, yesterday, lastUploadTime } = this
      const zebraH = (height - Math.round(height * (29 / 182)))
      // const grid = this.getCommonGridOpt()
      const grid = this.getGrid('bottom', this.getCommonGridOpt())
      const { oneHourW, width24Hour } = grid
      const canvasid4 = `pumpOneDayGraph_bar_${id}`
      const $canvas = document.getElementById(`${canvasid4}`).children[0].children[0]
      const ctx = $canvas.getContext('2d')

      /* ++++++++++计算出一天基础率++++++++++ */
      const { value, lfs, basalRateInfoMsg } = this
      const { threeChartData = {}, date, otherData = [] } = value
      const { insulinChart = {}} = threeChartData
      const { list: pumpRecord } = insulinChart
      
      const _basals_withoutAppendTwoPoints = _getPumpBasalFromRecords(pumpRecord)
      const _basals = _appendTwoPointsToBasals(date, _basals_withoutAppendTwoPoints, this.getDeadlineGaps(), this.yesterday, lastUploadTime)
      
      /* ++++++++++End of 计算出一天基础率++++++++++ */
      
      /* *********临时基础率********* */
      const _tempBasals = otherData.filter(_otherDataGetTempBasalFilter)
      const _tempBasalStopEvents = otherData.filter(_otherDataGetTempBasalStopFilter) // 用户强制终止临时基础率的输注
      derror(`otherData hasInited: ${hasInited}`, qcopy(otherData))
      derror(`_tempBasalStopEvents hasInited: ${hasInited}`, qcopy(_tempBasalStopEvents))
      /* *********End of 临时基础率********* */
      
      if (_basals.length) {
        // const $container = $(`#pumpDailyGraph_bar_${id} svg`)        
        
        const needDrawRst = []
        const asyncDrawCbs = [] // 异步画zebra图到canvas上
        const drawTitleRst = []
        const startOfDate = dayjs(date)
        const endOfDate = dayjs(date).add(1, 'day').subtract(1, 'second')
        
        const yesterdayDate = dayjs(date).subtract(1, 'day').format('YYYY-MM-DD')
        const yesterdayEndOfDate = dayjs(yesterdayDate).add(1, 'day').subtract(1, 'second')
        const yesterdayOtherData = yesterday['otherData'] || []
        
        /* ++++++++++根据前一天的临时基础率信息，判断是否要新增一条临时基础率到今天的开始时候（跨天）++++++++++ */
        do {
          if (yesterdayOtherData && yesterdayOtherData.length) {
            const otherData = yesterdayOtherData
            const _tempBasalsYes = (yesterdayOtherData.filter(_otherDataGetTempBasalFilter)).sort((first, second) => dayjs(first.dateTimeStr) - dayjs(second.dateTimeStr)) // 升序, dateTimeStr小的在数组前面
            const record = _tempBasalsYes[_tempBasalsYes.length - 1] // 最后一条，也就是yesterday最后一条临时基础率
            
            const isTempBasalVersion2 = _isTempBasalVersion2(record) // version2里头有临时基础率的持续时间信息
            if (isTempBasalVersion2) {
              const version2Duration = _getTempBasalDurationVersion2(record) // 单位: 小时
              let _tempDuration = version2Duration * 3600 // 单位秒              
              const start = +dayjs(record.dateTimeStr)
              const endTrue = dayjs(record.dateTimeStr).add(_tempDuration, 'second')
              const _durationToToday = endTrue.format('YYYY-MM-DD') !== `${yesterdayDate}`.trim()
              if (_durationToToday) {
                _tempDuration = 0
                // 昨天最后一个临时基础率持续到今天
                // 再判断一下昨天这个临时基础率之后是否已经被死线或者用户强制停止了
                // 还需要做额外的判断
                const deadGaps = this.getDeadlineGaps(yesterdayDate) // 一项的数据结构是: [starttimestamp, endtimestamp]
                const stopEvents = yesterdayOtherData.filter(_otherDataGetTempBasalStopFilter) // 用户强制终止临时基础率的输注
                const end = +yesterdayEndOfDate // 昨天的最后一刻(23:59:59)
                let dead // 死线
                let stop // 用户强制停止
                // 判断1, 这期间，是否有红线(死线)
                do {
                  const l = deadGaps.length
                  for (let i = 0; i < l; i++) {
                    const tmp = deadGaps[i]
                    const t = tmp[0]
                    const notInGap = (!(t - start >= 0 && t - end <= 0)) && (!(t - end >= 0 && t - start <= 0))
                    const inGap = !notInGap
                    if (inGap) {
                      dead = t
                      break
                    }
                  }
                  /* eslint-disable-next-line*/
                } while (false)
                
                // 判断2，这期间，是否有用户强制停止临时基础率的情况
                do {
                  const l = stopEvents.length
                  for (let i = 0; i < l; i++) {
                    const tmp = stopEvents[i]
                    const t = +dayjs(tmp['dateTimeStr'])
                    const notInGap = (!(t - start >= 0 && t - end <= 0)) && (!(t - end >= 0 && t - start <= 0))
                    const inGap = !notInGap
                    if (inGap) {
                      stop = t
                      break
                    }
                  }
                  /* eslint-disable-next-line*/
                } while (false)
                
                if (!stop && !dead) {
                  // 昨天最后的临时基础率，没有中途有停止(用户按了两下泵体，终止了临时基础率)、也没有死线
                  // 那么这个临时基础率会持续到今天
                  // 往今天的_tempBasals添加一天开始的临时基础率
                  const leftDuration = version2Duration * 3600 - ((yesterdayEndOfDate - start) / 1000) + 1
                  const leftDurationH = leftDuration / 3600 * 10
                  const fakeTempBasal = {
                    isFake: true,
                    dateTimeStr: startOfDate.format('YYYY-MM-DD HH:mm:ss'),
                    eventValue: leftDurationH, // 持续时间
                    eventType: record.eventType,
                    eventPort: record.eventPort,
                    statusByte0: record.statusByte0,
                    statusByte1: record.statusByte1,
                    statusShort0: record.statusShort0,
                    statusShort1: record.statusShort1,
                  }
                  derror(`昨天的临时基础率持续到今天, 插入一条假的临时基础率到今天的00:00, fakeTempBasal`, fakeTempBasal)
                  _tempBasals.unshift(fakeTempBasal)
                }
              }
            }
          }
          /* eslint-disable-next-line*/
        } while (false)
        /* ++++++++++End of 根据前一天的临时基础率信息，判断是否要新增一条临时基础率到今天的开始时候（跨天）++++++++++ */
        
        derror(`_basals_withoutAppendTwoPoints`, (qcopy(_basals_withoutAppendTwoPoints)).map(arr => {
          const [t, ...rest] = arr
          return [dayjs(t).format('YYYY-MM-DD HH:mm:ss'), ...rest]
        }))
        derror(`_basals`, (qcopy(_basals)).map(arr => {
          const [t, ...rest] = arr
          return [dayjs(t).format('YYYY-MM-DD HH:mm:ss'), ...rest]
        }))
        derror(`_tempBasals `, qcopy(_tempBasals))
        
        const l = _tempBasals.length
        if (!l) {
          console.warn(`${date}, 临时基础率为0，直接不画斑马矩形图`)
          return 
        }
        
        for (let i = 0; i < l; i++) {
          const record = _tempBasals[i]
          const isFake = record && record.isFake === true
          const settingIndex = record['statusByte1']
          const recordTime = record['dateTimeStr']
          const recordTimeDayjs = dayjs(recordTime)
          const isTempBasalVersion2 = _isTempBasalVersion2(record) // version2里头有临时基础率的持续时间信息
          let preBasalV
          
          if (!_isTempBasalVersion2Percent(record)) {
            // 老版本，或者新版本但不是%模式
            // step1, 获取预设值record发生时候(recordTime)的值
            const record = _tempBasals[i]
            const settingIndex = record['statusByte1']
            const recordTime = record['dateTimeStr']
            const baseI = findObjIndexInArray(sortedBasalRateBaseSetting, settingIndex, 'settingIndex')
            if (baseI < 0) {
              error(`[renderZebraBars]${date}, 临时基础率记录的预设基础率索引是: ${settingIndex},找不到相应的预设基础率,为了不让逻辑崩溃，直接continue到下一条`)
              continue
            }
            const base = sortedBasalRateBaseSetting[baseI]
            const { valueArray = '' } = base
            const preBasals = valueArray.split(',')
            const l2 = preBasals.length
            if (l2 < 48) {
              error(`[renderZebraBars]${date} 获取的预设基础率valueArray不足48个数值,有${l2}个数值, valueArray: ${valueArray}。为了不让逻辑崩溃，直接continue到下一条`)
              continue
            }
            if (l2 > 48) {
              derror(`[renderZebraBars]${date} 获取的预设基础率valueArray超过48个数值,有${l2}个数值, valueArray: ${valueArray}。`) // 提醒一下开发人员
            }
            const startOfDate = dayjs(date)
            const recordTimeDayjs = dayjs(recordTime)
            const diff = recordTimeDayjs.diff(startOfDate, 'hour', true)
            const recordPreBasalIndex = Math.floor(diff / 0.5) // 记录发生时候，对应预设值的时间段的index
            preBasalV = preBasals[recordPreBasalIndex]
            if (preBasalV === undefined) {
              error(`[renderZebraBars]${date}, recordTime: ${recordTime}, diff in hours: ${recordPreBasalIndex}, recordPreBasalIndex: ${recordPreBasalIndex}, preBasals.length: ${l2};为了逻辑不崩，直接continue`)
              continue
            }
          }
          
          do {
            let _tempDuration = 0 // 单位秒
            
            if (!isTempBasalVersion2) {
              // 老版本的逻辑，version1
              // 老版本里头，是没有临时基础率的持续时间的
              // 所以老版本的逻辑只能说算出来的持续时间是90%准确的，无法做到100%
              // 老版本，不存在画多个矩形；新版本，由于有duration字段存在，同时临时基础率还能设置能百分比。
              // 那么新版本。在duration存在时段里头，用户又设置成了百分比基础率的模式，那么此时可能就会有高低不同的各个矩形(也即实际执行基础率在这个duration时段里有多个值)
              const startPointRangeInfo = _whatBasalsRange(_basals, +recordTimeDayjs)
              
              const _v = startPointRangeInfo.value
              const _vIndex = startPointRangeInfo.index
              
              const basal = _basals[_vIndex] // 非临时基础率
              // const time = dayjs(basal[0])
              const time = +recordTimeDayjs
              const v = basal[1]
              const vs = `${v}`.trim()
              if (vs === 'undefined') {
                // 服务端说，临时基础率发生的时候，那时候会有一个真实基础率，这个真实基础率就是临时基础率的值
                error(`[renderZebraBars]${date}, recordTime: ${recordTime},在step3计算这个临时基础率的持续时间时, 发现这个临时基础率的发生时的实际基础率是undefined，这是不允许的`)
                break
              }
              let protecter = 1
              let nextB
              let nextI = _vIndex + 1
              do {
                protecter++
                nextB = _basals[nextI]
                if (!nextB) {
                  break
                }
                const time2 = dayjs(nextB[0])
                _tempDuration = (time2 - time)                
                
                nextI++
              } while (`${nextB[1]}`.trim() === vs || protecter > 100)
              _tempDuration /= (1000) // 单位秒
              
              if (_tempDuration === 0) { // 不画了
                break
              }
              
              // step2, 获取recordTime对应的实际执行量
              if (_vIndex < 0) {
                error(`[renderZebraBars]${date}, recordTime: ${recordTime},都遍历完实际基础率的数组了，也没有找到${recordTime}对应的时间段执行的基础率`)
                continue // 跳过，下一个
              }
              
              needDrawRst.push({
                version: 1,
                count: 1, // 只要画一个zebra矩形
                v: _v,
                duration: _tempDuration,
                sp: +recordTimeDayjs,
                spStr: recordTimeDayjs.format('HH:mm'),
                ep: +recordTimeDayjs.add(_tempDuration, 'second'),
                epStr: recordTimeDayjs.add(_tempDuration, 'second').format('HH:mm')
              })
              drawTitleRst.push({
                version: 1,
                sp: +recordTimeDayjs,
                spStr: recordTimeDayjs.format('HH:mm'),
                _v,
                v: `${_v} ${_v - preBasalV <= 0 ? '-' : '+'} ${(+preBasalV !== 0) ? (Math.abs(_v - preBasalV) / preBasalV * 100).toFixed(1) : '0'}% ${_tempBasalDuration(_tempDuration, isFake)}`,
                duration: _tempDuration
              })
            } else {
              // version2, 记录里头有持续时间的信息
              const version2Duration = _getTempBasalDurationVersion2(record) // 单位: 小时
              _tempDuration = version2Duration * 3600 // 单位秒
              const isV2Percent = _isTempBasalVersion2Percent(record) // version2,判断是不是百分比模式,如果不是的话，那么就值
              const v2Value = !isV2Percent ? (trimEndZero((record.statusShort0 / 160).toFixed(3))) : 0
              const start = +dayjs(record.dateTimeStr)
              const _end = +(dayjs(record.dateTimeStr).add(_tempDuration, 'second'))
              let end = +(dayjs(record.dateTimeStr).add(_tempDuration, 'second'))
              if (_end - lastUploadTime >= 0) {
                // 持续时间超过 lastUploadTime
                // 那么要将结束时间改成 lastUploadTime
                if (start - lastUploadTime >= 0) {
                  error(`[逻辑黑洞]临时基础率是version2的数据，带有持续时间。然后这个临时基础率的开始时间，竟然在最后一次上传数据的时刻之后? lastUploadTime: ${dayjs(lastUploadTime).format('YYYY-MM-DD HH:mm')}    直接不画这个临时基础率了`)
                  break
                } else {
                  end = lastUploadTime
                  _tempDuration = Math.floor((end - start) / 1000)
                }
              }
              // 还需要做额外的判断
              const deadGaps = this.getDeadlineGaps() // 一项的数据结构是: [starttimestamp, endtimestamp]
              const stopEvents = _tempBasalStopEvents // 每一项的数据结构是接口返回的otherData的其中一项的数据结构
              let dead // 死线
              let stop // 用户强制停止
              // 判断1, 这期间，是否有红线(死线)
              do {
                const l = deadGaps.length
                for (let i = 0; i < l; i++) {
                  const tmp = deadGaps[i]
                  const t = tmp[0]
                  const notInGap = (!(t - start >= 0 && t - end <= 0)) && (!(t - end >= 0 && t - start <= 0))
                  const inGap = !notInGap
                  if (inGap) {
                    dead = t
                    break
                  }
                }
                /* eslint-disable-next-line*/
              } while (false)
              
              // 判断2，这期间，是否有用户强制停止临时基础率的情况
              do {
                const l = stopEvents.length
                for (let i = 0; i < l; i++) {
                  const tmp = stopEvents[i]
                  const t = +dayjs(tmp['dateTimeStr'])
                  const notInGap = (!(t - start >= 0 && t - end <= 0)) && (!(t - end >= 0 && t - start <= 0))
                  const inGap = !notInGap
                  if (inGap) {
                    stop = t
                    break
                  }
                }
                /* eslint-disable-next-line*/
              } while (false)
              
              if (stop || dead) {
                // 中途有停止(用户按了两下泵体，终止了临时基础率)或者有死线
                const ends = ((([stop, dead]).filter(v => !!v)).sort((a, b) => a - b)) // 降序，最小的在最前面
                const breakPoint = ends[0]
                
                if (breakPoint) {
                  const duration = (breakPoint - start) / (1 * 1000) // 秒
                  
                  if (duration >= 0) {
                    // 更新_tempDuration
                    _tempDuration = duration
                  } else {
                    error(`[数据黑洞，逻辑黑洞]返回的临时基础率是version2,有持续时间信息;同时期间有死线或者停止事件，但是死线和停止事件的start时间点, 不在这个record的时间范围内，逻辑有问题。stop: ${stop}, dead: ${dead}; record是${JSON.stringify(record)}`)
                  } 
                }
              }
              
              // 实际的持续时间确定下来后,要判断一下这段时间里头有几个实际执行的值
              if (_tempDuration) { // 临时基础率的持续时间
                const startPointRangeInfo = _whatBasalsRange(_basals, +recordTimeDayjs)
                
                let _v = startPointRangeInfo.value
                if (!isV2Percent) {
                  // version2,是值的模式;
                  _v = v2Value
                }
                const _vIndex = startPointRangeInfo.index
                
                // 计算在这个持续时段里头，有几个实际执行的基础率值
                const _tempBasalTrueEndPoint = recordTimeDayjs.add(_tempDuration, 'second')
                const _isNextDay = _tempBasalTrueEndPoint.format('YYYY-MM-DD') !== `${date}`.trim()
                if (_isNextDay) { // 到第二天去了
                  _tempDuration = Math.floor((endOfDate - recordTimeDayjs - 1) / 1000) // 23:59:59再小一微秒
                }
                
                const _tempBasalEndPoint = recordTimeDayjs.add(_tempDuration, 'second')
                const endPointRangeInfo = _whatBasalsRange(_basals, +_tempBasalEndPoint)
                /* eslint-disable-next-line*/
                const basalsForDebugger = _basals.map(v => {
                  const [t, v0, ...rest] = v
                  const rst = [dayjs(t).format('DD HH:mm'), v0, ...rest]
                  return rst
                })
                
                const _evIndex = endPointRangeInfo['index']
                
                if (_vIndex < 0) {
                  error(`[数据黑洞，逻辑黑洞]找不到_vIndex, ${date}返回的临时基础率是version2,有持续时间信息;开始时间是：${recordTime}, 这个时间段却找不到实际的执行率`)
                  break
                }
                if (_evIndex < 0) {
                  error(`[有可能是跨天了。数据黑洞，逻辑黑洞]找不到_evIndex, ${date}返回的临时基础率是version2,有持续时间信息;开始时间是：${recordTime}, 获取到的version2的持续时间是： ${version2Duration}(/小时), 排除掉死线、人工停止等，实际的持续时间是:${_tempDuration} second, 这个时间段却找不到实际的执行率`)
                  break
                }
                
                const gap = _evIndex - _vIndex
                
                if (gap < 0) {
                  error(`[数据黑洞，逻辑黑洞]${date}返回的临时基础率是version2有持续时间信息，_evIndex却小于_vIndex，这是不对的.开始时间是：${recordTime}, _vIndex: ${_vIndex},获取到的version2的持续时间是： ${version2Duration}(/小时), 排除掉死线、人工停止等，实际的持续时间是:${_tempDuration} second, _evIndex: ${_evIndex}`)
                  break                  
                }                
                
                let maxBasalVInRange = -1
                
                for (let i = _vIndex; i <= _evIndex; i++) {
                  const trueBasal = _basals[i]
                  const v = !isV2Percent ? v2Value : trueBasal[1]
                  const tv = trueBasal[1]
                  const t = trueBasal[0]
                  const max = Math.max(+maxBasalVInRange, +tv)
                  
                  if (i - _evIndex >= 0) { // 最后一个,终点
                    // max计算应该不包含_evIndex
                    // maxBasalVInRange = (Number.isNaN(max)) ? maxBasalVInRange : max
                    
                    const endPoint = +_tempBasalEndPoint
                    let rst
                    
                    if (gap === 0) {
                      // 持续时间是实际运行的子集(_vIndex === _evIndex)
                      const sp = +recordTimeDayjs
                      rst = {
                        version: 2,
                        count: 1,
                        v: v,
                        sv: v,
                        sp,
                        spStr: dayjs(sp).format('HH:mm'),
                        duration: dayjs(endPoint).diff(dayjs(sp), 'second', true),
                        ep: endPoint,
                        epStr: dayjs(endPoint).format('HH:mm')
                      }
                    } else {
                      rst = {
                        version: 2,
                        count: 1,
                        v: v,
                        sv: v,
                        sp: t,
                        spStr: dayjs(t).format('HH:mm'),
                        duration: dayjs(endPoint).diff(dayjs(t), 'second', true),
                        ep: endPoint,
                        epStr: dayjs(endPoint).format('HH:mm')
                      } 
                    }    
                    
                    needDrawRst.push(rst)
                  } else { // 不是最后一个点
                    maxBasalVInRange = (Number.isNaN(max)) ? maxBasalVInRange : max
                    const nextI = i + 1
                    const next = _basals[nextI]
                    const endPoint = next[0]
                    const rst = {
                      version: 2,
                      count: 1,
                      v,
                      sv: v,
                      sp: t,
                      spStr: dayjs(t).format('HH:mm'),
                      duration: dayjs(endPoint).diff(dayjs(t), 'second', true),
                      ep: endPoint,
                      epStr: dayjs(endPoint).format('HH:mm'),
                      ev: next[1],
                      ei: nextI
                    }
                    if (i === _vIndex) { // 第一个点(即临时基础率事件的发生点)
                      rst.duration = dayjs(endPoint).diff(recordTimeDayjs, 'second', true)
                      rst.sp = +recordTimeDayjs
                      rst.spStr = recordTimeDayjs.format('HH:mm')
                    }
                    
                    needDrawRst.push(rst)
                  }
                }
                
                if (isV2Percent) {
                  // 临时基础率，是百分比
                  const percent = _getTempBasalVersion2Percent(record)
                  
                  // if (percent && percent >= 0) {
                  const rst = {
                    version: 2,
                    sp: +recordTimeDayjs,
                    spStr: recordTimeDayjs.format('HH:mm'),
                    v: `${(+percent).toFixed(0)}% ${_tempBasalDuration(_tempDuration, _isNextDay || isFake)}`,
                    duration: _tempDuration
                  }
                  if (maxBasalVInRange >= 0) {
                    rst._v = maxBasalVInRange
                  }
                  drawTitleRst.push(rst) 
                  // } else {
                  //   error(`[数据错误]临时基础率是version2，同时又是百分比模式，但是取出来的百分比不合法.record: `, record)
                  // }
                } else {
                  // 临时基础率，是值
                  drawTitleRst.push({
                    version: 2,
                    sp: +recordTimeDayjs,
                    spStr: recordTimeDayjs.format('HH:mm'),
                    _v,
                    v: `${_v} ${_v - preBasalV <= 0 ? '-' : '+'} ${(+preBasalV !== 0) ? (Math.abs(_v - preBasalV) / preBasalV * 100).toFixed(1) : '0'}% ${_tempBasalDuration(_tempDuration, _isNextDay || isFake)}`,
                    duration: _tempDuration
                  })
                }
              }
            }
            
            /* eslint-disable-next-line*/
          } while (false)                   
          
          derror(`needDrawRst,`, needDrawRst)
          this._needDrawRst = needDrawRst          
        }
        
        // step4, 开始画图
        const tenthHeight = (1 / 11) * (zebraH * 1 - 1.9 * lfs) // 基础率值为1对应的高度；如果echarts的y纵坐标变化了， 那么这个tenthHeight要跟着变;
        const paddingBottom = (60 / 12) * lfs
        
        for (let i = 0; i < needDrawRst.length; i++) {
          derror(`before render zebra`)
          const uiInfo = needDrawRst[i]
          if (!uiInfo) {
            error(`[逻辑黑洞]当前用来画斑马图zebra的uiInfo是空的, needDrawRst`, needDrawRst)
            continue
          }
          
          const isVersion1 = uiInfo && +uiInfo.version === 1
          const _tempDuration = uiInfo.duration // 单位秒
          const _v = uiInfo.v
          const w = oneHourW * _tempDuration / 3600
          const recordTimeDayjs = dayjs(uiInfo.sp)
          const diff = recordTimeDayjs.diff(startOfDate, 'hour', true)
          const h = tenthHeight * 2 * _transferBasalData(_v)
          const xoffset = diff / 24 * grid.width24Hour + grid.left
          
          // const _tempTitle = `${_v} ${_v - preBasalV <= 0 ? '-' : '+'} ${(+preBasalV !== 0) ? (Math.abs(_v - preBasalV) / preBasalV * 100).toFixed(1) : '0'}% ${_tempBasalDuration(_tempDuration)}`
          // const titleX = xoffset + w / 2 - 2.5 * lfs
          // const titleY = height - paddingBottom - 0.8 * lfs
          const titleX = w / 2
          const titleY = -0.8 * lfs
          
          const translate = `translate(${xoffset}, ${height - h - paddingBottom})`
          
          derror(`before render zebra22, `, $canvas)
          
          derror(`before render zebra33, paddingBottom`, {
            paddingBottom, height, h, w, grid, lfs
          })

          asyncDrawCbs.push(() => {
            this.renderZebraRect(ctx, { rect: {
              x: xoffset,
              y: height - h - paddingBottom,
              width: w + (0.0048 * oneHourW), // 加个buffer,免得空出来从而出现白线
              height: h
            }})
          })
        }
        
        // // 画title
        // for (let i = 0; i < drawTitleRst.length; i++) {
        //   const title = drawTitleRst[i]
        //   // const isVersion2 = (`${title.version}`.trim()) === '2'
        //   const _tempDuration = title.duration
        //   const recordTimeDayjs = dayjs(title.sp)
        //   const _tempTitle = title.v
        //   const diff = recordTimeDayjs.diff(startOfDate, 'hour', true)
        //   const xoffset = diff / 24 * grid.width24Hour + grid.left
        //   const w = oneHourW * _tempDuration / 3600
        //   const titleX = w / 2 + xoffset
        //   const h = tenthHeight * 2 * _transferBasalData(title._v)
        //   const titleY = height - h - 0.8 * lfs - paddingBottom          

        //   asyncDrawCbs.push(() => {
        //     // 画个辅助线
        //     ctx.setLineDash([~~(lfs * 0.4), ~~(lfs * 0.2)])
        //     ctx.strokeStyle = 'black'
        //     ctx.beginPath()
        //     ctx.moveTo(titleX, titleY + 0.8 * lfs)
        //     ctx.lineTo(titleX, titleY)
        //     ctx.stroke()

        //     // 再写title
        //     ctx.setLineDash([]) // 切回实线
        //     ctx.font = `100 ${labelSize}px sans-serif`
        //     // ctx.fontSize = `${labelSize}px`
        //     // ctx.fontWeight = `100`
        //     ctx.strokeStyle = basalC
        //     ctx.textAlign = 'center'
        //     // ctx.globalCompositeOperation = 'destination-over' // 画到原有图(echarts画的)下面
        //     ctx.globalCompositeOperation = 'source-over' // 画到原有图(echarts画的)之上
        //     // ctx.textBaseline = ''
        //     ctx.strokeText(_tempTitle, titleX, titleY)
        //   })
        //   // $title.appendTo($container)
        // }

        this._zebraDrawed = true
        asyncDrawCbs.forEach(cb => {
          cb() 
        })
        // // async do draw(异步画canvas图)
        // setTimeout(() => {
        //   this._zebraDrawed = true
        //   asyncDrawCbs.forEach(cb => cb())
        // }, 1000 * 1.5)
      } else { // 
        derror(`zebra柱形图已画过，不再画`)
      }
    },
    renderZebraRect(context, extra = {}) {
      const { rect = {}} = extra
      const { x = 0, y = 0, width = 0, height = 0 } = rect
      if (!width || !height) {
        derror(`renderZebraRect的长宽有一个为空，那么不画斑马图了`, extra)
        return false
      } else {
        try {
          const tile = this.createTile()
          derror(`renderZebraRect, rect. typeof context: ${typeof context};typeof context.createPattern: ${typeof context.createPattern}`, {
            extra,
            tile
          })
          context.globalCompositeOperation = 'destination-over' // 画到原有图(echarts画的)下面
          // context.globalCompositeOperation = 'source-over' // 画到原有图(echarts画的)之上
          context.fillStyle = context.createPattern(tile, 'repeat')
          // context.fillStyle = 'red'
          context.fillRect(x, y, width, height)
        } catch (error) {
          console.error('renderZebraRect被捕获:' + error)
        }
      }
    },
    createTile: function _createTile(extra = {}) {
      // const { w = 30, c1 = '#9AE0FB', c2 = '#7DD7FB' } = extra
      const { w = 10 } = extra
      const opa = 1
      const c1 = `rgba(154, 224, 251, ${opa})`
      const c2 = `rgba(125, 215, 251, ${opa})`
      if (_createTile._cache) {
        return _createTile._cache
      }
      
      const tile = document.createElement('canvas')
      tile.width = tile.height = w
      const tileCtx = tile.getContext('2d')
      const gradient = tileCtx.createLinearGradient(0, 0, tile.width, tile.height)
      
      gradient.addColorStop(0, c1)
      gradient.addColorStop(0.25, c1)
      gradient.addColorStop(0.25, c2)
      gradient.addColorStop(0.5, c2)
      gradient.addColorStop(0.5, c1)
      gradient.addColorStop(0.75, c1)
      gradient.addColorStop(0.75, c2)
      gradient.addColorStop(1, c2)
      tileCtx.fillStyle = gradient
      tileCtx.fillRect(0, 0, w, w)
      
      _createTile._cache = tile

      return tile
    },
    initChart() {
      const { id } = this
      const canvasid = `pumpOneDayGraph_${id}`
      const canvasid2 = `pumpOneDayGraph_co_${id}`
      const canvasid3 = `pumpOneDayGraph_bar_${id}`
      try {
        const myChart = this.$echarts.init(document.getElementById(`${canvasid}`), null, { renderer: 'svg' })
        const opt = this.getOpt('initChart')
        
        myChart.setOption(opt)
        
        const myChart2 = this.$echarts.init(document.getElementById(`${canvasid2}`), null, { renderer: 'svg' })
        const opt2 = this.getOptIcon('initChart')
        
        myChart2.setOption(opt2)
        
        this._myCharts = [myChart, myChart2]

        const myChart3 = this.$echarts.init(document.getElementById(`${canvasid3}`), null, { renderer: 'canvas' })
        const opt3 = this.getOptBar('initChart')
        myChart3.on('finished', () => {
          this.renderZebraBars({ hasInited: false })
        })
        myChart3.setOption(opt3)
        
        this._myCharts = [myChart, myChart2, myChart3]
      } catch (err) {
        error('被捕获:' + err)
      }
    },
    updateChart() {
      const newOpt = this.getOpt('updateChart')
      const newOptIcon = this.getOptIcon('updateChart')
      const newOptBar = this.getOptBar('updateChart')
      
      this.$nextTick(() => {
        try {
          const myChart = this._myCharts[0]
          if (myChart) {
            myChart.setOption(newOpt)            
          }

          const myChartIcon = this._myCharts[1]
          if (myChartIcon) {
            myChartIcon.setOption(newOptIcon)
          }

          const myChartBar = this._myCharts[2]
          if (myChartBar) {
            myChartBar.setOption(newOptBar)
          }
        } catch (err) {
          error('被捕获:' + err)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
